import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Animated, Keyboard, TouchableOpacity, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {getApp} from '../../../../../actions/app';
import {showSheet} from '../../../../../actions/SheetActions';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
import FieldHeader from '../../../../../components/fields/field-header/FieldHeader.component';
import ValidLabelField from '../../../../../components/fields/valid-label-field/ValidLabelField.component';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import {useEmail} from '../../../../../hooks/useValidations';
import {selectrootsheettype} from '../../../../../selectors/SheetSelector';
import styles from './EmailSheet.style';
import { selecetusertype } from '../../../../../selectors/User';

export default function EmailSheet(props) {
  const {} = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const translateY = useRef(new Animated.Value(421)).current;
  const [validationEnabled, setValidationEnabled] = useState(false);
  const {sheetId} = useSelector(state => selectrootsheettype(state));
  const emailState = useSelector(state => state?.app?.email);
  const {info} = useSelector(state => selecetusertype(state));

  useEffect(() => {
    switch (sheetId) {
      case 'email':
        Animated.timing(translateY, {
          toValue: 0,
          duration: 400,
          useNativeDriver: true,
        }).start();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  useEffect(()=>{
    if ( emailState ) {
      setEmail(emailState)
    }else {
      setEmail(info?.email)
    }
  },[])

  const closeHandler = () => {
    Animated.timing(translateY, {
      toValue: 421,
      duration: 400,
      useNativeDriver: true,
    }).start();
    setTimeout(() => {
      dispatch(showSheet({sheetId: ''}));
    }, 400);
  };

  const {
    value: email,
    setValue: setEmail,
    result: emailValidation,
    checkError: emailCheckError,
  } = useEmail(!validationEnabled);

  function onSubmit() {
    Keyboard.dismiss();
    if (emailCheckError()) {
      setValidationEnabled(true);
    } else {
      dispatch(getApp({email: email}));
      closeHandler();
    }
  }

  return (
    <>
      <TouchableOpacity
        activeOpacity={1}
        onPress={closeHandler}
        style={styles.container}
      />
      <Animated.View
        style={[{transform: [{translateY: translateY}]}, styles.content]}>
        <View style={styles.indicator} />
        <FabBackButton
          container_style={styles.closeBtn}
          onPress={closeHandler}
          icon={'closeIcon'}
        />
        <FieldHeader text={t('enter_email')} containerStyle={styles.title} />
        <ValidLabelField
          inputStyle={{
            flex: undefined,
          }}
          labelText={t('email')}
          returnKeyType="done"
          keyboardType="email-address"
          onEndEditing={onSubmit}
          value={email}
          onChangeText={setEmail}
          isError={validationEnabled && emailCheckError()}
          errorText={emailValidation.error}
          {...props}
        />
        <PrimaryButton
          title={t('record')}
          containerStyle={styles.button}
          onPress={onSubmit}
        />
      </Animated.View>
    </>
  );
}
